export function fileToDataUri(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (event.target) resolve(event.target.result)
      else alert('Could not convert the uploaded file to an image!')
    }
    reader.readAsDataURL(file)
  })
}

export function parseTimeStringToMinutes(
  timeString: string | undefined,
): number {
  if (!timeString) return NaN
  const match = timeString.match(/^(\d{1,2}):(\d{2})$/)
  if (!match) return NaN
  const hours = parseInt(match[1], 10)
  const minutes = parseInt(match[2], 10)
  if (hours >= 24 || minutes >= 60) return NaN // Validate time range
  return hours * 60 + minutes
}
